export default "__VITE_ASSET__B2AyIPnk__"